import React from 'react';
import { createPortal } from 'react-dom';
import { Icon } from '/imports/ui/Icon';

interface ModalStyledProps {
  className?: string;
  children?: React.ReactNode;
}

export const ModalStyled = (props: ModalStyledProps) => (
  <div className={props.className}>{props.children}</div>
);

export interface ModalProps {
  title?: string | React.ReactNode;
  body?: string | React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  buttons?: React.ReactNode;
  onClose?(): void;
  styled?: any;
}

export const Modal = (props: ModalProps) => {
  return createPortal(
    React.createElement(props.styled || ModalStyled, {
      className: `modal ${props.className || ''}`,
    },
    /*
     * Three bands (header, body, footer) rather than one p-10 block, so the
     * title and actions read as chrome and the body owns its own scrolling.
     * Anchored near the top instead of vertically centred: a centred dialog
     * jumps around as its content grows. The overlay was a hardcoded
     * old-brand blue.
     */
    <div className="modal-overlay fixed top-0 left-0 z-100 flex h-full w-full flex-col items-center overflow-auto bg-overlay px-4 py-[12vh]">
      <div className="modal-window relative m-auto box-border flex max-h-full max-w-full flex-col overflow-hidden rounded-card border border-soft bg-panel shadow-chunky-lg">
        <div className="modal-header flex shrink-0 items-center justify-between gap-3 border-b border-soft px-5 py-3.5">
          <h1 className="modal-title min-w-0 truncate text-[15px] font-bold">{props.title || ''}</h1>
          <span className="modal-close shrink-0 cursor-pointer text-fg-3 hover:text-fg-1" onClick={props.onClose}>
            <Icon icon="close" size={18} />
          </span>
        </div>
        <div className="modal-body min-h-0 flex-1 overflow-auto px-5 py-4">
          {props.children || props.body || ''}
        </div>
        {props.buttons
          ? (
            <div className="modal-buttons flex shrink-0 justify-end gap-2 border-t border-soft bg-page-alt px-5 py-3.5">
              {props.buttons}
            </div>
          )
          : null}
      </div>
    </div>
    ),
    document.body
  );
};
